import React from 'react';
import { Phone, Facebook, Instagram, Linkedin, Youtube, Twitter, MapPin, Clock, Mail } from 'lucide-react';
import { Logo } from '../LogoWhite';
export interface FooterProps {
  'data-id'?: string;
}
export const Footer: React.FC<FooterProps> = ({
  'data-id': dataId
}) => {
  return <footer data-id={dataId} className="w-full bg-[#002f4b] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-42">
        {/* Top Section: Logo and Contact */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-12 gap-8 text-center lg:text-left" data-id="element-43">
          {/* Logo */}
          <div className="flex justify-center lg:justify-start" data-id="element-44">
            <Logo width={140} data-id="element-45" />
          </div>

          {/* Contact Info and Social Icons */}
          <div className="flex flex-col gap-6" data-id="element-46">
            {/* Contact Info - shows on all screens */}
            <div className="flex flex-wrap items-center justify-center gap-6" data-id="element-47">
              <a href="tel:8001200399" className="flex items-center gap-2 hover:text-[#0af] transition-colors" data-id="element-48">
                <Phone size={20} data-id="element-49" />
                <span className="font-medium" data-id="element-50">800-1200-399</span>
              </a>
              <a href="https://wa.me/528148007977" className="flex items-center gap-2 hover:text-[#0af] transition-colors" data-id="element-51">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-52">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-53" />
                </svg>
                <span className="font-medium" data-id="element-54">(81) 4800 7977</span>
              </a>

              {/* Social Media Icons - inline on md+ screens */}
              <div className="hidden md:flex items-center gap-4" data-id="element-55">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-56">
                  <Facebook size={24} data-id="element-57" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-58">
                  <Instagram size={24} data-id="element-59" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-60">
                  <Linkedin size={24} data-id="element-61" />
                </a>
                <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-62">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-63">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-64" />
                  </svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-65">
                  <Youtube size={24} data-id="element-66" />
                </a>
                <a href="https://x.com/farmaciavitau" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-67">
                  <Twitter size={24} data-id="element-68" />
                </a>
              </div>
            </div>

            {/* Social Media Icons - separate row on small screens only */}
            <div className="flex md:hidden items-center justify-center gap-4" data-id="element-69">
              <a href="https://facebook.com/vitau.mx" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-70">
                <Facebook size={24} data-id="element-71" />
              </a>
              <a href="https://instagram.com/vitau.mx" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-72">
                <Instagram size={24} data-id="element-73" />
              </a>
              <a href="https://linkedin.com/company/vitau" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-74">
                <Linkedin size={24} data-id="element-75" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-76">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-77">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-78" />
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-79">
                <Youtube size={24} data-id="element-80" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0af] transition-colors" data-id="element-81">
                <Twitter size={24} data-id="element-82" />
              </a>
            </div>
          </div>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 text-center lg:text-left" data-id="element-83">
          {/* Column 1: Address & Hours */}
          <div className="space-y-4" data-id="element-84">
            <div className="flex items-start gap-3 justify-center lg:justify-start" data-id="element-85">
              <MapPin size={18} className="flex-shrink-0 mt-0.5" data-id="element-86" />
              <p className="text-sm leading-relaxed text-left" data-id="element-87">
                Gral. Pablo González Garza #620,
                <br data-id="element-88" />
                Chepevera, Monterrey N.L. 64030
              </p>
            </div>
            <div className="flex items-start gap-3 justify-center lg:justify-start" data-id="element-89">
              <Clock size={18} className="flex-shrink-0 mt-0.5" data-id="element-90" />
              <p className="text-sm leading-relaxed text-left" data-id="element-91">
                Lunes a viernes: 7AM-7PM
                <br data-id="element-92" />
                Sábado: 9AM-1PM
              </p>
            </div>
            <div className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-93">
              <Mail size={18} className="flex-shrink-0" data-id="element-94" />
              <a href="mailto:info@vitau.mx" className="text-sm hover:text-[#0af] transition-colors" data-id="element-95">
                info@vitau.mx
              </a>
            </div>

            {/* Regulatory Information */}
            <div className="pt-4 border-t border-white/10" data-id="element-96">
              <p className="text-xs leading-relaxed text-white/70 text-center lg:text-left" data-id="element-97">
                Responsable Sanitario: Jommors Olvera Muñoz (Ced. Prof. 6407754)
                <br data-id="element-98" />
                Licencia Sanitaria: 19039090963
                <br data-id="element-99" />
                Aviso de Funcionamiento: 2519015011X00063
              </p>
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div className="space-y-3" data-id="element-100">
            <a href="/farmacia" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-101">
              Farmacia
            </a>
            <a href="/suscripciones" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-102">
              Suscripciones
            </a>
            <a href="/suscripciones" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-103">
              Centros de Salud
            </a>
            <a href="/suscripciones" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-104">
              Doctores
            </a>
            <a href="/blog" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-105">
              Blog
            </a>
            <a href="/nosotros" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-106">
              Nosotros
            </a>
          </div>

          {/* Column 3: Support */}
          <div className="space-y-3" data-id="element-107">
            <a href="/preguntas-frecuentes" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-108">
              Preguntas frecuentes
            </a>
            <a href="/politicas-cancelacion" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-109">
              Políticas de cancelación
            </a>
            <a href="/facturacion" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-110">
              Facturación
            </a>
            <a href="/devoluciones-envios" className="block text-sm hover:text-[#0af] transition-colors" data-id="element-111">
              Devoluciones y envíos
            </a>
            <a href="/para-doctores" className="block text-sm hover:text-[#0af] transition-colors mt-6" data-id="element-112">
              Para doctores
            </a>
          </div>

          {/* Column 4: Apps & Certification */}
          <div className="space-y-4 flex flex-col items-center lg:items-end" data-id="element-113">
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="block w-36" data-id="element-114">
              <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/es-mx?size=250x83&releaseDate=1280620800" alt="Descargar en App Store" className="w-full h-auto rounded" data-id="element-115" />
            </a>
            <a href="https://play.google.com" target="_blank" rel="noopener noreferrer" className="block w-36" data-id="element-116">
              <img src="https://play.google.com/intl/en_us/badges/static/images/badges/es_badge_web_generic.png" alt="Disponible en Google Play" className="w-full h-auto rounded" data-id="element-117" />
            </a>
          </div>
        </div>

        {/* Certification Badges Row */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-8" data-id="element-118">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pDpb535Z77hBMhPUVVGFH8/cofepris.svg" alt="COFEPRIS - Comisión Federal para la Protección contra Riesgos Sanitarios" className="h-16" data-id="element-119" />
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qW6dhnUJX1BSV2DXN6hE8J/profeco-distintivo-digital.svg" alt="PROFECO - Distintivo Digital" className="h-16" data-id="element-120" />
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-[#00aaff]" data-id="element-121"></div>

      {/* Bottom Section */}
      <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-122">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-center md:text-left" data-id="element-123">
          <p className="text-white/80" data-id="element-124">
            © 2025 Vitau. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-125">
            <a href="/terminos-condiciones" className="text-[#0af] hover:text-[#08c] transition-colors" data-id="element-126">
              Términos y condiciones
            </a>
            <a href="/aviso-privacidad" className="text-[#0af] hover:text-[#08c] transition-colors" data-id="element-127">
              Aviso de privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
};